// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.DailyItem
 */
export class DailyItem extends Message<DailyItem> {
  /**
   * @generated from field: int32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string item_name = 2;
   */
  itemName = "";

  /**
   * @generated from field: string item_type = 3;
   */
  itemType = "";

  /**
   * @generated from field: bool is_marked = 4;
   */
  isMarked = false;

  /**
   * The ID of the checklist this item belongs to
   *
   * @generated from field: int32 checklist_id = 5;
   */
  checklistId = 0;

  constructor(data?: PartialMessage<DailyItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DailyItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "item_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_marked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "checklist_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DailyItem {
    return new DailyItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DailyItem {
    return new DailyItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DailyItem {
    return new DailyItem().fromJsonString(jsonString, options);
  }

  static equals(a: DailyItem | PlainMessage<DailyItem> | undefined, b: DailyItem | PlainMessage<DailyItem> | undefined): boolean {
    return proto3.util.equals(DailyItem, a, b);
  }
}

